<div *ngIf="(confirmDialogService.getMessage() | async) as message" class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">{{message.title}}</p>
            <button class="button is-black is-small" aria-label="close" (click)="cancel()">
                <span class="icon">
                    <i class="mdi mdi-close"></i>
                </span>
            </button>
        </header>
        <section class="modal-card-body">
            {{message.content}}
        </section>
        <footer class="modal-card-foot">
            <button
                class="button has-text"
                [ngClass]="{'is-loading': confirmDialogService.requestRunning}"
                (click)="confirm()"
                [disabled]="confirmDialogService.requestRunning"
            >OK</button>
            <button class="button has-text" (click)="cancel()">Cancel</button>
        </footer>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/layout/configrm-dialog/confirm-dialog.component.html